import { useStorage } from '@vueuse/core'
import { watchEffect } from 'vue'

export type Theme = 'light' | 'dark' | 'auto'

const theme = useStorage<Theme>('theme', 'auto')

function applyTheme(value: Theme) {
    const root = document.documentElement

    if (value === 'auto') {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        root.setAttribute('data-theme', prefersDark ? 'dark' : 'light')
    } else {
        root.setAttribute('data-theme', value)
    }
}

export function useTheme() {
    watchEffect(() => {
        applyTheme(theme.value)
    })

    // Listen for system theme changes when in auto mode
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        if (theme.value === 'auto') {
            applyTheme('auto')
        }
    })

    function setTheme(value: Theme) {
        theme.value = value
    }

    return {
        theme,
        setTheme,
    }
}
